import { render } from "./About.vue?vue&type=template&id=1b4b1427"
const script = {}

import "./About.vue?vue&type=style&index=0&id=1b4b1427&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__